import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNotificationCore } from '../../core/modules/notification';
import { useAuthCore } from '../../core/modules/auth';

const NotificationListener = () => {
  const location = useLocation();
  const { token } = useAuthCore();
  const { getUnreadNotifications } = useNotificationCore();

  useEffect(() => {
    if (token) {
      getUnreadNotifications();
    }
  }, [location, getUnreadNotifications, token]);

  return null;
};

export default NotificationListener;
